/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { NavController } from '@ionic/angular';
import { NavigationOptions } from '@ionic/angular/common/providers/nav-controller';

@Injectable({
  providedIn: 'root',
})
export class TakeOverTourActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'takeovertour';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private navigationController: NavController,
    private zone: NgZone,
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    let formId = params.formid;

    let navParams: NavigationOptions = {
      queryParams: {
        formId: formId,
      },
    };
    this.zone.run(() => {
      this.navigationController.navigateForward(
        '/feature/takeovertour',
        navParams,
      );
    });
  }

  // Private Functions
}
